/**
 * Helpers for the reviewer-password session state.
 *
 * Split from ``ReviewerGate.tsx`` so React Fast Refresh keeps working —
 * the Vite ``react-refresh`` plugin requires component files to export
 * components only. Consumers (the gate itself, the AppShell sign-out
 * button) pull from here.
 */

export const REVIEWER_SESSION_KEY = 'raydn:reviewer-authed';

/**
 * Read the configured reviewer password from the Vite env. Lazy rather
 * than module-scoped so tests can mutate the env before rendering.
 * Returns an empty string when no password is set — callers should
 * treat that as "gate disabled".
 */
export function readConfiguredPassword(): string {
  return import.meta.env.VITE_REVIEWER_PASSWORD ?? '';
}

/** `true` when a password is configured in the bundle. */
export function isGateConfigured(): boolean {
  return Boolean(readConfiguredPassword());
}

/**
 * End the current session. Safe to call regardless of gate state —
 * clears the flag and forces a full reload so any in-memory state
 * (runs, hits, drafts) is dropped alongside.
 */
export function signOut(): void {
  try {
    sessionStorage.removeItem(REVIEWER_SESSION_KEY);
  } catch {
    // sessionStorage may be unavailable (e.g. embedded contexts).
  }
  window.location.reload();
}
